isFromAbs